// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"4e05c78a","361":"5c6f1c69","643":"9d62127b","767":"f67b7078"}[chunkId] + ".chunk.js";
};